function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const SpreadsheetIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 2v28h32V2H0zm12 18v-6h8v6h-8zm8 2v6h-8v-6h8zm0-16v6h-8V6h8zM10 6v6H2V6h8zm-8 8h8v6H2v-6zm20 0h8v6h-8v-6zm0-2V6h8v6h-8zM2 22h8v6H2v-6zm20 6v-6h8v6h-8z"
  }));
};
export default SpreadsheetIcon;